import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { User } from '@/types/TAccounts';

const accountState = (state: RootState) => state.account;

export const getAuthenticationStatus = createSelector(
	[accountState],
	(accountState) => accountState.isAuthenticated,
);

export const getLoggedInUser = createSelector(
	[accountState],
	(accountState) => accountState.userAccount,
);
export const getSelectedAgent = createSelector([accountState], (accountState) => accountState.user);

export const getAllAgents = createSelector([accountState], (accountState) => accountState.agents);
export const getSelectedAgentId = createSelector(
	[accountState],
	(accountState) => accountState.selectedAgentId,
);
export const getAgentById = createSelector([accountState], (accountState) =>
	accountState.agents.find((agent: User) => agent.number === accountState.selectedAgentId),
);
export const getInboundAgents = createSelector([accountState], (accountState) =>
	accountState.agents.filter((agent: User) => agent.type === 'Inbound'),
);

export const getOutboundAgents = createSelector([accountState], (accountState) =>
	accountState.agents.filter((agent: User) => agent.type === 'Outbound'),
);

export const getUserInstructionSteps = createSelector(
	[accountState],
	(accountState) => accountState.user?.instruction_steps,
);

export const getUserFeatures = createSelector(
	[accountState],
	(accountState) => accountState?.userAccount?.features,
);

export const getcurrentPage = createSelector(
	[accountState],
	(accountState) => accountState?.currentPage,
);

export const getActiveConfigureTab = createSelector(
	[accountState],
	(accountState) => accountState?.activeConfigureTab,
);

export const getResellerUserFeaturesVisibility = createSelector(
	[accountState],
	(accountState) => accountState?.user?.featuresSubAccount?.visibility?.featureVisibilitySidebar,
);

export const getResellerUserFeaturesGating = createSelector(
	[accountState],
	(accountState) => accountState?.user?.featuresSubAccount?.gating?.featureGatingSidebar,
);
export const getResellerUserConfigureVisibility = createSelector(
	[accountState],
	(accountState) => accountState?.user?.featuresSubAccount?.visibility?.configureVisibility,
);
export const getResellerUserConfigureGating = createSelector(
	[accountState],
	(accountState) => accountState?.user?.featuresSubAccount?.gating?.configureGating,
);

export const getResellerUserAdvanceFeaturesVisibility = createSelector(
	[accountState],
	(accountState) => accountState?.user?.featuresSubAccount?.visibility?.advanceFeaturesVisibility,
);
export const getResellerUserAdvanceFeaturesGating = createSelector(
	[accountState],
	(accountState) => accountState?.user?.featuresSubAccount?.gating?.advanceFeaturesGating,
);

export const getAgentPreview = createSelector(
	[accountState],
	(accountState) => accountState?.agentPreview,
);

export const getCrmGroups = createSelector(
	[accountState],
	(accountState) => accountState.crmGroups,
);
